<template>
  <div class="content">
    <div class="left-content">
      <tree-components
        ref="treeComponents"
        :treeList='treeList'
        :defaultProps='defaultProps'
        @handleNodeChange='handleNodeChange'
        @handleGetTreeList='handleGetTreeList'
        >
      </tree-components>
    </div>
    <div class="right-content">
      <company-info
        ref="companyInfo"
        :companyName='companyName'
        :tel='tel'
        >
      </company-info>
      <card-content
        ref="cardContent"
        :dataList="switchList"
        :tableData="tableData"
        :isSwitch='true'
        >
      </card-content>
    </div>
  </div>
</template>

<script>
import Socket from '@/utils/websocket'
import treeComponents from './treeComponents.vue'
import companyInfo from './companyInfo.vue'
import cardContent from './cardContent.vue'
export default {
  name: 'roomElectricity',
  components: {
    treeComponents,
    companyInfo,
    cardContent
  },
  data () {
    return {
      activeName: 'card',
      activeNode: '',
      treeList: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      companyName: '',
      tel: '',
      dataList: [],
      tableData: [],
      webSocket: null,
      webSocketOptions: {
        ip: '',
        key: '',
        path: '',
        port: ''
      },
      switchList: []
    }
  },
  created () {
    this.handleGetTreeList()
  },
  methods: {
    async handleGetTreeList () {
      this.treeList = []
      let res = await this.$api.rentalArea.getRentalAreaTrusteeshipContractForProperty(0, [], '', '', '', '', 1)
      if (res.success) {
        let areaList = []
        res.data.forEach((item) => {
          areaList = areaList.concat(item.areas)
        })
        let areaIdList = areaList.map((item) => {
          return item.id
        })
        this.$api.rentalArea.getSubRentalAreas(areaIdList, 1).then((res) => {
          if (res.success) {
            this.handleTreeList(res.data)
            this.dataList = [res.data[0]]
            this.activeNode = res.data[0].id
            this.$nextTick(() => {
              this.$refs['treeComponents'].handleSetCurrentKey(res.data[0].id)
            })
            this.handleGetRoomSwitches()
          }
        })
      }
    },
    handleTreeList (list) {
      let allListId = list.map((item) => {
        return item.id
      })
      // 找不到parentId的，pid为0
      list.forEach((item) => {
        item.pid = item.parentId
        if (allListId.indexOf(item.parentId) === -1) {
          item.pid = 0
        }
      })
      this.treeList = this.handleRecursion(list, 0)
    },
    handleRecursion (list, pid) {
      let arr = []
      list.forEach((item) => {
        if (item.pid === pid) {
          item.children = this.handleRecursion(list, item.id)
          arr.push(item)
        }
      })
      // console.log(arr)
      return arr
    },
    handleNodeChange (data) {
      this.activeNode = data.id
      this.dataList = this.handleGetAllLeaf([data])
      this.handleGetRoomSwitches()
    },
    handleGetAllLeaf (data) {
      let result = []
      const getLeaf = (nodeList) => {
        nodeList.forEach((item) => {
          if (item.children.length === 0) {
            result.push(item)
          } else {
            getLeaf(item.children)
          }
        })
      }
      getLeaf(data)
      return result
    },
    handleGetRoomSwitches () {
      this.switchList = []
      let requestList = this.dataList.map((item) => {
        return this.$api.rentalArea.getRentalAreaSwitches(item.id)
      })
      Promise.all(requestList).then((res) => {
        if (res[0].success) {
          this.dataList = this.dataList.map((item, index) => {
            return {
              ...item,
              switchList: res[index].data
            }
          })
          // res.forEach((item) => {
          //   this.switchList = this.switchList.concat(item.data)
          // })
          for (let i = 0; i < res.length; i++) {
            let list = res[i].data.map((item) => {
              return {
                ...item,
                Ia: '',
                Ib: '',
                Ic: '',
                Ua: '',
                Ub: '',
                Uc: '',
                P: '',
                Q: '',
                S: '',
                onOffStatus: true
              }
            })
            this.switchList = this.switchList.concat(list)
          }
          this.$forceUpdate()
          console.log(this.switchList)
          this.handleGetWebsocketUrl()
        }
      })
    },
    handleGetWebsocketUrl () {
      this.$api.measuringServer.allotMeasuringRealtimeNotifyServer().then((res) => {
        if (res.success) {
          this.webSocketOptions = Object.assign({}, res.data)
          this.handleWebSocketInit()
        }
      })
    },
    handleWebSocketInit () {
      if (this.webSocket !== null) {
        this.webSocket.close()
      }
      let result = ''
      this.webSocket = new Socket({
        url: window.baseConfig.wsAgreement + '://' + this.webSocketOptions.ip + ':' + this.webSocketOptions.port + '/' + this.webSocketOptions.path
      })
      this.webSocket.onopen(() => {
        console.log(this.webSocketOptions.key)
        this.webSocket.send({
          methodCode: '101',
          key: this.webSocketOptions.key
        })
      })
      this.webSocket.onmessage((res) => {
        result = JSON.parse(res)
        console.log('result', result)
        try {
          for (let i = 0; i < this.switchList.length; i++) {
            for (let j = 0; j < result.data.length; j++) {
              if (result.data[j].measureId === this.switchList[i].id) {
                switch (result.data[j].data[0].pointCode) {
                  case 201:
                    this.switchList[i].Ua = result.data[j].data[0].value
                    break
                  case 202:
                    this.switchList[i].Ub = result.data[j].data[0].value
                    break
                  case 203:
                    this.switchList[i].Uc = result.data[j].data[0].value
                    break
                  case 207:
                    this.switchList[i].Ia = result.data[j].data[0].value
                    break
                  case 208:
                    this.switchList[i].Ib = result.data[j].data[0].value
                    break
                  case 209:
                    this.switchList[i].Ic = result.data[j].data[0].value
                    break
                  case 211:
                    this.switchList[i].P = result.data[j].data[0].value
                    break
                  case 215:
                    this.switchList[i].Q = result.data[j].data[0].value
                    break
                  case 223:
                    this.switchList[i].S = result.data[j].data[0].value
                    break
                  case 601:
                    this.switchList[i].onOffStatus = result.data[j].data[0].value === '1' ? true : false
                    break
                }
              }
            }
          }
        } catch (error) {
          console.log(error)
        }
        this.handdleWebSocketOnmessage(result)
      })
    },
    handdleWebSocketOnmessage (res) {
      console.log('handdleWebSocketOnmessage')
      if (res.methodCode === '102') {
        let switchInfo = []
        switchInfo = this.switchList.map((item) => {
          return {
            id: item.id,
            points: [
              { code: 201, number: 0 },
              { code: 202, number: 0 },
              { code: 203, number: 0 },
              { code: 207, number: 0 },
              { code: 208, number: 0 },
              { code: 209, number: 0 },
              { code: 211, number: 0 },
              { code: 215, number: 0 },
              { code: 223, number: 0 },
              { code: 601, number: 10002 }
            ]
          }
        })
        console.log(switchInfo)
        let requsetInfo = switchInfo
        this.webSocket.send({
          methodCode: '103',
          measures: requsetInfo
        })
      }
    },
    handleBeforeLeave () {
      console.log('handleBeforeLeave')
      if (this.webSocket !== null) {
        this.webSocket.close()
      }
    }
  },
  beforeDestroy () {
    console.log('beforeDestroy')
    if (this.webSocket !== null) {
      this.webSocket.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  .left-content {
    width: 240px;
    height: 100%;
    // border: 1px solid;
    box-sizing: border-box;
  }
  .right-content {
    margin-left: 16px;
    width: calc(100% - 256px);
    height: 100%;
    // border: 1px solid;
    box-sizing: border-box;
  }
}

.el-tabs {
  height: 100%;
  ::v-deep .el-tabs__content{
    height: calc(100% - 60px);
  }
  ::v-deep .el-tabs__nav {
    float: right;
  }
  .el-tab-pane {
    height: 100%;
  }
}
</style>
